import { render, staticRenderFns } from "./quick-insert-product.vue?vue&type=template&id=4b2c59e1&"
import script from "./quick-insert-product.vue.ts?vue&type=script&lang=ts&"
export * from "./quick-insert-product.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports